<template>
  <div class="app-showcase-process-step section-space--pb_30">
    <div class="container" v-if="blocks">
      <div v-for="(block,index) in blocks.data.blocks" :key="index">
        <LoginScreen :id="block.id" :left="block.left" :img="block.img" :title="block.title" :subtitle="block.subtitle"
                     :desc="block.desc"/>
        <div class="mb-30"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoginScreen from "../components/LoginScreen";

export default {
  computed: {
    blocks() {
      return this.$store.getters['app/content']('9a401ed7-52ff-4c02-9a8b-2139e9753c1a')
    }
  },
  components: {
    LoginScreen
  }
};
</script>

<style lang="scss">

</style>